export default "/icon-nav-clients.svg";